import { css } from '@emotion/react';

import { COLORS2 } from '@/Client/Styles';
import { styleguideColors } from '@/Client/Styles/kaiShikiTokens';
import { MODAL_COLORS } from '@/Client/Widgets/Modal/ModalStyleLib';
import { styleguideFontFamily as FONT } from '@kaiizen/kai-shiki/core';

import { pxToRem } from '@/Client/Styles/pxToRem';
import { ACCENT, DARK_BG } from '../scanVideoMediaStyles';

// Styles for AIScanVideoUploadModal live here (co-located, like Widgets/CountInput/) so the
// modal component stays focused on behavior and its look can be restyled in one place
// without touching the component.
//
// The modal head/foot chrome and the file list row + thumbnail primitives are shared with the
// VideoToolbox; they live in ../scanVideoMediaStyles and are re-exported here so this
// Partial's existing imports keep resolving.

export {
  EYEBROW_STYLE,
  FILE_INFO_STYLE,
  FILE_LIST_STYLE,
  FILE_NAME_STYLE,
  FILE_ROW_TOP_STYLE,
  fileListScrollStyle,
  fileRowStyle,
  fileSubStyle,
  fileThumbStyle,
  FOOT_ACTIONS_STYLE,
  FOOT_WITH_HINT_STYLE,
  HEAD_STYLE,
  SUBTITLE_STYLE,
  TITLE_STYLE,
} from '../scanVideoMediaStyles';
export { ACCENT, DARK_BG };

export const SUCCESS = COLORS2.alwaysDark.green;

// ********************************************************************
// Upload screen
// ********************************************************************

export const DROPZONE_STYLE = css`
  label: AI_SCAN_DROPZONE;
  margin-top: 22px;
  border: 1.5px dashed ${MODAL_COLORS.border};
  background: ${styleguideColors.surfaceMuted};
  padding: 36px 24px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;

  &:focus-visible {
    outline: 2px solid ${MODAL_COLORS.text};
    outline-offset: 2px;
  }
`;

export const dropzoneDraggingStyle = css`
  border-color: ${MODAL_COLORS.text};
  background: ${styleguideColors.wash};
`;

export const dropzoneFullStyle = css`
  opacity: 0.5;
  cursor: not-allowed;
`;

export const DROPZONE_ICON_STYLE = css`
  label: AI_SCAN_DROPZONE_ICON;
  display: block;
  margin: 0 auto 14px;
  color: ${MODAL_COLORS.textMuted};
`;

export const DROPZONE_TITLE_STYLE = css`
  label: AI_SCAN_DROPZONE_TITLE;
  font-family: ${FONT.display};
  font-size: ${pxToRem(16)};
  font-weight: 700;
  color: ${MODAL_COLORS.text};
`;

export const DROPZONE_SUBTITLE_STYLE = css`
  label: AI_SCAN_DROPZONE_SUBTITLE;
  margin-top: 6px;
  font-family: ${FONT.body};
  font-size: ${pxToRem(13)};
  color: ${MODAL_COLORS.textMuted};
`;

export const DROPZONE_BROWSE_STYLE = css`
  font-family: ${FONT.body};
  color: ${MODAL_COLORS.text};
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
`;

export const FOOT_HINT_STYLE = css`
  label: AI_SCAN_FOOT_HINT;
  flex: 1;
  min-width: 0;
  font-family: ${FONT.mono};
  font-size: ${pxToRem(10)};
  font-weight: 700;
  letter-spacing: 0.05em;
  color: ${MODAL_COLORS.textMuted};
  text-transform: uppercase;
  line-height: 1.5;
`;

export const footHintErrorStyle = css`
  color: ${COLORS2.alwaysDark.red};
`;

export const FILE_REMOVE_STYLE = css`
  label: AI_SCAN_FILE_REMOVE;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  background: none;
  border: none;
  cursor: pointer;
  color: ${MODAL_COLORS.textMuted};
  font-size: ${pxToRem(18)};
  line-height: 1;
  padding: 4px;
  &:hover {
    color: ${COLORS2.alwaysDark.red};
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const BAR_TRACK_STYLE = css`
  label: AI_SCAN_BAR_TRACK;
  height: 3px;
  background: ${MODAL_COLORS.border};
  overflow: hidden;
`;

export const barFillStyle = (pct: number, color: string) =>
  css`
  label: AI_SCAN_BAR_FILL;
  height: 100%;
  width: ${pct}%;
  background: ${color};
  transition: width 0.3s linear;
`;

export const ERROR_STYLE = css`
  label: AI_SCAN_ERROR;
  margin-top: 14px;
  font-family: ${FONT.body};
  font-size: ${pxToRem(13)};
  color: ${COLORS2.alwaysDark.red};
`;
